export const PROMO_PHOTO_TILE_SIZE = 25;
